export default __webpack_public_path__ + "static/0-e51bceb31d0e444f462ab0021c3a283d.png";